import { useRef, useState } from "react";
import { PENTA, tone } from "@/lib/babySound";

const HUES = [20, 45, 160, 200, 280, 330];

export const GlowTouch = () => {
  const [glows, setGlows] = useState([]);
  const last = useRef(0);
  const id = useRef(0);
  const add = (e) => {
    const now = Date.now();
    if (e.type === "pointermove" && (e.buttons === 0 && e.pointerType === "mouse" || now - last.current < 140)) return;
    last.current = now;
    const g = { id: id.current++, x: e.clientX, y: e.clientY, hue: HUES[Math.floor(Math.random() * HUES.length)] };
    tone(PENTA[Math.min(PENTA.length - 1, Math.floor((e.clientX / window.innerWidth) * PENTA.length))], 1.4, { type: "sine", vol: 0.12 });
    setGlows((x) => [...x.slice(-24), g]);
    setTimeout(() => setGlows((x) => x.filter((y) => y.id !== g.id)), 2600);
  };
  return (
    <div className="absolute inset-0 bg-[#0E1A24] touch-none" onPointerDown={add} onPointerMove={add} data-testid="game-glow">
      {glows.map((g) => <span key={g.id} className="absolute pointer-events-none rounded-full baby-glow" style={{ left: g.x - 110, top: g.y - 110, width: 220, height: 220,
        background: `radial-gradient(circle, hsla(${g.hue},90%,70%,0.95), hsla(${g.hue},90%,60%,0.3) 45%, transparent 70%)` }} />)}
      {!glows.length && <p className="absolute inset-x-0 top-1/2 text-center text-white/40 font-display text-2xl pointer-events-none">Touch anywhere</p>}
    </div>
  );
};
